import React, { useState, useEffect, useCallback } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from 'shared/theme';
import { useParams } from 'react-router-dom';
import useSessionService from 'shared/api/services/sessionService';
import Table from 'shared/components/Table';
import Header from 'shared/components/Header';
import ClockLoader from 'shared/components/ClockLoader';

const formatEndReason = (reason) => {
  if (!reason || String(reason).trim() === '') return '—';
  return String(reason)
    .trim()
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const displaySessionTime = (value) => {
  if (value == null || value === '' || value === 'NO DATE SPECIFIED') {
    return '—';
  }
  return value;
};

const Sessions = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { userId } = useParams();
  const { sessions, totalRecords, fetchSessions, isLoading } = useSessionService();
  const [page, setPage] = useState(0);
  const [size] = useState(10);

  useEffect(() => {
    if (userId) {
      fetchSessions(userId, page, size);
    }
  }, [userId, page, size, fetchSessions]);

  const handlePageChange = useCallback((newPage) => {
    if (!Number.isNaN(newPage)) {
      setPage(newPage);
    }
  }, []);

  const columns = [
    {
      field: 'start',
      headerName: 'Logged in',
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => displaySessionTime(params.row?.start),
    },
    {
      field: 'end',
      headerName: 'Logged out',
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => {
        const end = params.row?.end;
        if (end == null || end === '' || end === 'NO DATE SPECIFIED') {
          return params.row?.status === 'ACTIVE' ? 'Still logged in' : '—';
        }
        return end;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.7,
      minWidth: 120,
    },
    {
      field: 'endReason',
      headerName: 'End reason',
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => formatEndReason(params.row?.endReason),
    },
  ];

  return (
    <Box m="0px">
      <Box p={2} ml={2} mr={2}>
        <Header title="User sessions" />
        {isLoading && sessions.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
            <ClockLoader size={48} />
          </Box>
        ) : (
          <Table
            tableId="platform.user-sessions"
            title="User sessions"
            rows={sessions}
            columns={columns}
            totalRecords={totalRecords}
            size={size}
            page={page}
            handlePageChange={handlePageChange}
            colors={colors}
          />
        )}
      </Box>
    </Box>
  );
};

export default Sessions;
